"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("./core");
var util_1 = require("../utils/util");
var ODataDefaultParser = /** @class */ (function (_super) {
    __extends(ODataDefaultParser, _super);
    function ODataDefaultParser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ODataDefaultParser;
}(core_1.ODataParserBase));
exports.ODataDefaultParser = ODataDefaultParser;
var ODataValueParserImpl = /** @class */ (function (_super) {
    __extends(ODataValueParserImpl, _super);
    function ODataValueParserImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ODataValueParserImpl.prototype.parse = function (r) {
        return _super.prototype.parse.call(this, r).then(function (d) { return d; });
    };
    return ODataValueParserImpl;
}(core_1.ODataParserBase));
function ODataValue() {
    return new ODataValueParserImpl();
}
exports.ODataValue = ODataValue;
var ODataRawParserImpl = /** @class */ (function (_super) {
    __extends(ODataRawParserImpl, _super);
    function ODataRawParserImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ODataRawParserImpl.prototype.parseImpl = function (r, resolve) {
        r.json().then(resolve);
    };
    return ODataRawParserImpl;
}(core_1.ODataParserBase));
exports.ODataRawParserImpl = ODataRawParserImpl;
exports.ODataRaw = new ODataRawParserImpl();
var TextFileParser = /** @class */ (function (_super) {
    __extends(TextFileParser, _super);
    function TextFileParser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextFileParser.prototype.parseImpl = function (r, resolve) {
        r.text().then(resolve);
    };
    return TextFileParser;
}(core_1.ODataParserBase));
exports.TextFileParser = TextFileParser;
var BlobFileParser = /** @class */ (function (_super) {
    __extends(BlobFileParser, _super);
    function BlobFileParser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlobFileParser.prototype.parseImpl = function (r, resolve) {
        r.blob().then(resolve);
    };
    return BlobFileParser;
}(core_1.ODataParserBase));
exports.BlobFileParser = BlobFileParser;
var JSONFileParser = /** @class */ (function (_super) {
    __extends(JSONFileParser, _super);
    function JSONFileParser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JSONFileParser.prototype.parseImpl = function (r, resolve) {
        r.json().then(resolve);
    };
    return JSONFileParser;
}(core_1.ODataParserBase));
exports.JSONFileParser = JSONFileParser;
var BufferFileParser = /** @class */ (function (_super) {
    __extends(BufferFileParser, _super);
    function BufferFileParser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BufferFileParser.prototype.parseImpl = function (r, resolve) {
        if (util_1.Util.isFunction(r.arrayBuffer)) {
            r.arrayBuffer().then(resolve);
        }
        r.buffer().then(resolve);
    };
    return BufferFileParser;
}(core_1.ODataParserBase));
exports.BufferFileParser = BufferFileParser;



//////////////////
// WEBPACK FOOTER
// ./lib/odata/parsers.js
// module id = 7
// module chunks = 0